export class VaerifyUser {
  public FirstName?: string;
  public LastName?: string;
  public PhoneNumber!: string;
  public Id?: any;
  public CreationType!: string;
}
